import type { ProjectStatus } from '@catalyst-psa/shared';

import type { Badge } from '../../components/ui/Badge.js';

type BadgeTone = Parameters<typeof Badge>[0]['tone'];

export const PROJECT_STATUS_LABELS: Record<ProjectStatus, string> = {
  active: 'Active',
  on_hold: 'On hold',
  completed: 'Completed',
  cancelled: 'Cancelled',
};

export const PROJECT_STATUS_TONES: Record<ProjectStatus, BadgeTone> = {
  active: 'green',
  on_hold: 'amber',
  completed: 'blue',
  cancelled: 'gray',
};
